var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchoolIconLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99988 24.21L4.37988 22.13C1.20288 20.702 1.20988 17.295 4.37988 15.87L20.2749 8.716C22.3979 7.761 25.6049 7.762 27.7249 8.716L43.6209 15.869C46.7969 17.299 46.7889 20.705 43.6209 22.131L38.9999 24.21V32.5C38.9999 37.113 32.1749 40 23.9999 40C15.8249 40 8.99988 37.113 8.99988 32.5V24.21ZM34.9999 26.01L27.7249 29.284C25.6019 30.239 22.3949 30.238 20.2749 29.284L12.9999 26.01V32.5C12.9999 32.978 13.8229 33.8 15.5869 34.547C17.7469 35.461 20.7589 36 23.9999 36C27.2399 36 30.2529 35.46 32.4129 34.547C34.1769 33.801 34.9999 32.977 34.9999 32.5V26.01ZM26.0839 12.364C25.0069 11.879 22.9949 11.878 21.9159 12.364L7.16988 19L21.9169 25.636C22.9939 26.121 25.0059 26.122 26.0849 25.636L40.8299 19L26.0839 12.364Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolIconLight);
export default __webpack_public_path__ + "static/media/schoolIconLight.6234bfdc58edfb4837e248a11aad5059.svg";
export { ForwardRef as ReactComponent };